// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--38f43";
export var centreAddress = "styles-module--centreAddress--ceb20";
export var centreTitle = "styles-module--centreTitle--a6523";
export var container = "styles-module--container--caeb5";
export var logoContainer = "styles-module--logoContainer--ed6d9";
export var popupContent = "styles-module--popupContent--b9e0f";